import React from 'react';
import Lottie from 'lottie-react';
import animation from './animation.json';

const ProfileScreenAnimation = () => <Lottie animationData={ animation } />;

export default ProfileScreenAnimation;
